import {
  BulkChangePriceMode,
  OlxAdvert,
  OlxAdvertActionPayload,
  OlxAvailablePackage,
  OlxLocation,
  OlxPaidFeatureCode,
  PLANNER_OLX_ACTION,
} from '../../../../../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';
import { FormControl, FormGroup } from '@angular/forms';
import { DropdownItem } from '../../../../dropdown-v2/dropdown-v2.interface';
import {
  PLANNER_AUTOMATION_ACTION,
} from '../../../../../modules/crm/automation-v2/components-v2/automation-v2/automation-v2.interface';

export interface PlannerItem {
  id: string;
  active: boolean;
  created_at: string;
  company_id: string;
  structure_type: PLANNER_STRUCTURE;
  parent_id?: string;
  scope: PLANNER_SCOPE;
  action: PlannerActionType;
  title: string;
  status: PLANNER_STATUS;
  schedule: PlannerSchedule;
  next_trigger_at?: string;
  last_triggered_at?: string;
  occurrences_count: number;
  payload: PlannerPayload;
  last_error?: PlannerError;
  parent_name?: string;
}

export enum PLANNER_STATUS {
  ACTIVE = 'ACTIVE',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  DISABLED = 'DISABLED',
  FAILED = 'FAILED',
  WARNING = 'WARNING',
  DRAFT = 'DRAFT',
}

export interface PlannerError {
  code?: string;
  at?: string;
  context?: any;
}

export enum PLANNER_STRUCTURE {
  DEFAULT = 'DEFAULT',
  GROUP = 'GROUP',
}

export enum PLANNER_SCHEDULE_TYPE {
  ONCE = 'ONCE',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  CUSTOM = 'CUSTOM',
}

export const PLANNER_SCHEDULE_TYPES: DropdownItem[] = [
  { name: 'planner.schedule.type.once', value: PLANNER_SCHEDULE_TYPE.ONCE },
  { name: 'planner.schedule.type.daily', value: PLANNER_SCHEDULE_TYPE.DAILY },
  { name: 'planner.schedule.type.weekly', value: PLANNER_SCHEDULE_TYPE.WEEKLY },
  { name: 'planner.schedule.type.monthly', value: PLANNER_SCHEDULE_TYPE.MONTHLY },
  { name: 'planner.schedule.type.custom', value: PLANNER_SCHEDULE_TYPE.CUSTOM },
];

export enum PLANNER_WEEK_DAY {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export const PLANNER_WEEK_DAYS: DropdownItem[] = [
  { name: 'planner.schedule.days_of_week.mon', value: PLANNER_WEEK_DAY.MON },
  { name: 'planner.schedule.days_of_week.tue', value: PLANNER_WEEK_DAY.TUE },
  { name: 'planner.schedule.days_of_week.wed', value: PLANNER_WEEK_DAY.WED },
  { name: 'planner.schedule.days_of_week.thu', value: PLANNER_WEEK_DAY.THU },
  { name: 'planner.schedule.days_of_week.fri', value: PLANNER_WEEK_DAY.FRI },
  { name: 'planner.schedule.days_of_week.sat', value: PLANNER_WEEK_DAY.SAT },
  { name: 'planner.schedule.days_of_week.sun', value: PLANNER_WEEK_DAY.SUN },
];

export enum PLANNER_END_CONDITION_TYPE {
  NEVER = 'NEVER',
  AFTER = 'AFTER',
  ON_DATE = 'ON_DATE',
}

export const PLANNER_END_CONDITIONS: DropdownItem[] = [
  { name: 'planner.schedule.end_condition_type.never', value: PLANNER_END_CONDITION_TYPE.NEVER },
  { name: 'planner.schedule.end_condition_type.after', value: PLANNER_END_CONDITION_TYPE.AFTER },
  { name: 'planner.schedule.end_condition_type.on_date', value: PLANNER_END_CONDITION_TYPE.ON_DATE },
];

export enum PLANNER_TIME_UNIT {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export const PLANNER_TIME_UNITS: DropdownItem[] = [
  { name: 'planner.schedule.time_unit.minute', value: PLANNER_TIME_UNIT.MINUTE },
  { name: 'planner.schedule.time_unit.hour', value: PLANNER_TIME_UNIT.HOUR },
  { name: 'planner.schedule.time_unit.day', value: PLANNER_TIME_UNIT.DAY },
  { name: 'planner.schedule.time_unit.week', value: PLANNER_TIME_UNIT.WEEK },
  { name: 'planner.schedule.time_unit.month', value: PLANNER_TIME_UNIT.MONTH },
];

export interface PlannerSchedule {
  type: PLANNER_SCHEDULE_TYPE | null;
  time: string | null;
  start_date: string | null;
  step?: {
    number: number | null;
    unit: PLANNER_TIME_UNIT | null;
  };
  end_condition?: {
    type: PLANNER_END_CONDITION_TYPE | null;
    max_occurrences?: number | null;
    until_date?: string | null;
  };
  repeat?: {
    unit: PLANNER_TIME_UNIT | null;
    every: number | null;
  };

  // TODO
  days_of_week?: PLANNER_WEEK_DAY[] | null;
  days_of_month?: number[] | null;
  timezone?: string | null;
  custom_cron?: string | null;
}

export enum PLANNER_SCOPE {
  OLX = 'OLX',
  AUTOMATION = 'AUTOMATION',
}

export interface PlannerActionsDropdownItem {
  name: string;
  value: PlannerActionType;
  planner_config?: PlannerConfig;
}

export interface PlannerConfig {
  checkboxes: {
    key: string;
    label: string;
  }[];
}

export type PlannerActionType =
  | PLANNER_OLX_ACTION
  | PLANNER_AUTOMATION_ACTION;

export interface PlannerBasePayload {
  is_telegram?: boolean;
}

export interface PlannerOlxPayload extends PlannerBasePayload {
  channel_id: string;
  advert_id?: number;
  advert?: OlxAdvertActionPayload | OlxAdvert;
  selected_package?: OlxAvailablePackage;
  location?: OlxLocation;
  replacement?: boolean;
  delete_anyway?: boolean;
  codes?: OlxPaidFeatureCode[];
  mode?: BulkChangePriceMode;
  value?: number;

  [key: string]: any;
}

export type PlannerPayload = PlannerOlxPayload;

export enum PlannerSidebarMode {
  Create,
  Update,
}

export interface PlannerSidebarData {
  mode: PlannerSidebarMode;
  scope: PLANNER_SCOPE;
  actions: PlannerActionsDropdownItem[];
  payloads: PlannerPayload[];

  planner_id?: string;
  title?: string;
  status?: PLANNER_STATUS;
  action?: PlannerActionType;
  schedule?: PlannerSchedule;
  occurrences_count?: number;

  check_existing?: PlannerCheckExisting;
}

export interface PlannerForm {
  title: FormControl<string | null>;
  status: FormControl<PLANNER_STATUS | null>;
  action: FormControl<PlannerActionType | null>;
  scope: FormControl<PLANNER_SCOPE | null>;
  schedule: FormGroup<ScheduleForm>;
  payloads: FormControl<PlannerPayload[] | null>;
  planner_id: FormControl<string | null>;
  price_change?: FormGroup<PriceChangeForm>;
}

export interface ScheduleForm {
  type: FormControl<PLANNER_SCHEDULE_TYPE | null>;
  time: FormControl<string | null>;
  start_date: FormControl<string | null>;
  step?: FormGroup<ScheduleStepForm>;

  end_condition?: FormGroup<ScheduleEndConditionForm>;
  repeat?: FormGroup<ScheduleRepeatForm>;
  days_of_week?: FormControl<PLANNER_WEEK_DAY[] | null>;
  days_of_month?: FormControl<number[] | null>;
  timezone?: FormControl<string | null>;
  custom_cron?: FormControl<string | null>;
}

export interface ScheduleStepForm {
  number: FormControl<number | null>;
  unit: FormControl<PLANNER_TIME_UNIT | null>;
}

export interface ScheduleEndConditionForm {
  type: FormControl<PLANNER_END_CONDITION_TYPE | null>;
  max_occurrences: FormControl<number | null>;
  until_date: FormControl<string | null>;
}

export interface ScheduleRepeatForm {
  unit: FormControl<PLANNER_TIME_UNIT | null>;
  every: FormControl<number | null>;
}

export interface PriceChangeForm {
  mode: FormControl<BulkChangePriceMode | null>;
  value: FormControl<number | null>;
}

export interface PlannerUpsertPayload {
  planner_id: string | null;
  title: string | null;
  scope: PLANNER_SCOPE | null;
  action: PlannerActionType | null;
  status?: PLANNER_STATUS | null;
  schedule: PlannerSchedule;
  payloads: PlannerPayload[] | null;
}

export interface PlannerUpdateStatusPayload {
  planner_ids: string[];
  status: PLANNER_STATUS;
}

export interface ToggleArchivePlannersPayload {
  planner_ids: string[];
  active: boolean;
}

export const PLANNER_SCOPE_TG_NOTIF_DISABLED: PLANNER_SCOPE[] = [
  PLANNER_SCOPE.AUTOMATION,
];

export interface PlannerCheckExisting {
  active?: boolean;
  status?: PLANNER_STATUS;
  action?: PlannerActionType;
  payload: Record<string, any>[];
}
